import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { addDoc, collection, query, where, deleteDoc, onSnapshot, doc, setDoc, updateDoc, getDocs, limit, orderBy } from "firebase/firestore";
import { db } from "../firebase.js";
import Lodinging from "../components_root/loading.jsx";
import Lodingingimg from "../components_root/loadingimg.jsx";
import Cookies from "js-cookie";
import './dashboard.css';
import { Toast } from '../components_root/ToastContext';
import { VscDashboard } from "react-icons/vsc";
import { MdAnalytics, MdDashboard, MdHome, MdLocationCity, MdMenu, MdMonitor, MdOutlineAnalytics, MdOutlineDeleteForever, MdSettings, MdSettingsAccessibility, MdTraffic } from "react-icons/md";
import { deleteFileByUid as deleteFileFromServer } from "../components_root/deleteFileByUid.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};


export default function File_uploaded() {
    const [text, setText] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(true);
    const [collapsed, setCollapsed] = useState(false);
    const [activeTab, setActiveTab] = useState("home");
    const [product_filedata, setProduct_filedata] = useState([]);

useEffect(() => {
    setIsLoading(true);
    const companyuid = Cookies.get("select_company_uid");

    const q = query(
        collection(db, "files"),
        where("companyuid", "==", companyuid)
    );

    // Real-time listener
    const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
            const datafiles = snapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setProduct_filedata(datafiles);
            setIsLoading(false);
        },
        (err) => {
            console.error("Error fetching file data:", err);
            setIsLoading(false);
        }
    );

    // Cleanup listener on unmount
    return () => unsubscribe();
}, []);

// Format file size
    function formatFileSize(bytes) {
        if (bytes === 0) return "0 B";
        const units = ["B", "KB", "MB", "GB", "TB"];
        let size = bytes;
        let unitIndex = 0;

        while (size >= 1024 && unitIndex < units.length - 1) {
            size /= 1024;
            unitIndex++;
        }

        return size.toFixed(2) + " " + units[unitIndex];
    }

const handleDeleteFile = async (uid) => {
  // Delete from Firebase/Server first
  const rse = await deleteFileFromServer(uid);

  if (rse.success) {
    // Only remove from state if deletion worked
   // setProduct_filedata((prevData) => prevData.filter((item) => item.uid !== uid));
    Toastshow("File deleted successfully", "success");
  } else {
    Toastshow(`Error deleting file: ${rse.error}`, "error");
  }
};
    return (
        <div>
       <div className="ui-grid m-b m-top">
              <div className="ui-items items-back-fill runded b-1 p-1 ">
            <table>
                <tr>
    <td  >Total Files</td>
     <td className="center" >Total Size</td>
                </tr>
            <tr>
<td className="text-h2 bold ">{formatFileSize(product_filedata.reduce((acc, file) => acc + (file.size || 0), 0))}</td>
<td className="text-h1 bold center">{product_filedata.length}</td>
            </tr>
            </table>
            </div>
            </div>
<div className="ui-grid ">
  {isLoading ? (
    <Lodinging />
  ) : product_filedata.length === 0 ? (
    <div>No categories found</div>
  ) : (
    product_filedata.map((row, index) => (
      <div className="ui-items items-back b-1 p-1 " key={index}>
        <img  style={{width:"100%",maxHeight:"200px",objectFit:"contain"}} className="rounded" src={row.url} />
        <div className="bold fcap text-h2">{row.filename}</div>
         <div className="text-h3">ID: {row.uid}</div>
        <div className="text-h3">Create: {row.date_time?.toDate ? (
                                                    (() => {
                                                        const dateObj = row.date_time.toDate();
                                                        return `${dateObj.toLocaleDateString()} ${dateObj.toLocaleTimeString()}`;
                                                    })()
                                                ) : (
                                                    "No data"
                                                )}</div>
        <table>
          <tr>
            <td><div className="text-h3">{formatFileSize(row.size)}</div></td>
            <td><div className="text-h3">{row.type}</div></td>
          
            <td>
              <div 
                onClick={() => handleDeleteFile(row.uid)} 
                className="button-ui2 border cursor"
              >
                <MdOutlineDeleteForever className="icon" />Delete
              </div>
            </td>
          </tr>
        </table>
      </div>
    ))
  )}
</div>
        </div>
    );
}
